const FIELDS = [
    // --- Erträge / Betriebseinnahmen ------------------------------------------
    {
        kz: '9040',
        label: 'Erträge/Betriebseinnahmen (Waren-/Leistungserlöse)',
        section: 'betriebseinnahmen',
        direction: 'income',
        hint: 'Pflichtfeld — auch bei 0 einzutragen (§ 61 Abs 5 BAO). Ohne Erlöse laut Mitteilung § 109a.',
    },
    {
        kz: '9050',
        label: 'Erträge/Betriebseinnahmen, die in einer Mitteilung gemäß § 109a erfasst sind',
        section: 'betriebseinnahmen',
        direction: 'income',
        hint: 'Pflichtfeld — auch bei 0 einzutragen.',
    },
    {
        kz: '9060',
        label: 'Anlagenerträge/Entnahmewerte von Anlagevermögen',
        section: 'betriebseinnahmen',
        direction: 'income',
        hint: 'Verkaufserlöse und Entnahmewerte aus dem Anlagenabgang.',
    },
    {
        kz: '9090',
        label: 'Übrige Erträge/Betriebseinnahmen — Saldo',
        section: 'betriebseinnahmen',
        direction: 'income',
    },
    {
        kz: '9093',
        label: 'Nur bei USt-Bruttosystem: vereinnahmte USt für Lieferungen und sonstige Leistungen',
        section: 'betriebseinnahmen',
        direction: 'income',
        hint: 'Nur auszufüllen, wenn brutto verbucht wird.',
    },
    // --- Aufwendungen / Betriebsausgaben --------------------------------------
    {
        kz: '9100',
        label: 'Waren, Rohstoffe, Hilfsstoffe',
        section: 'betriebsausgaben',
        direction: 'expense',
    },
    {
        kz: '9110',
        label: 'Beigestelltes Personal (Fremdpersonal) und Fremdleistungen',
        section: 'betriebsausgaben',
        direction: 'expense',
    },
    {
        kz: '9120',
        label: 'Personalaufwand („eigenes Personal")',
        section: 'betriebsausgaben',
        direction: 'expense',
    },
    {
        kz: '9130',
        label: 'Abschreibungen auf das Anlagevermögen (AfA, geringwertige Wirtschaftsgüter)',
        section: 'betriebsausgaben',
        direction: 'expense',
        computed: true,
        hint: 'Wird aus dem Anlagenverzeichnis berechnet, soweit nicht in 9134/9135 zu erfassen.',
    },
    {
        kz: '9134',
        label: 'Degressive Absetzung für Abnutzung (§ 7 Abs 1a)',
        section: 'betriebsausgaben',
        direction: 'expense',
        computed: true,
    },
    {
        kz: '9135',
        label: 'Beschleunigte Gebäudeabschreibung (§ 8 Abs 1a und § 124b Z 451)',
        section: 'betriebsausgaben',
        direction: 'expense',
        computed: true,
    },
    {
        kz: '9150',
        label: 'Instandhaltungen (Erhaltungsaufwand) für Gebäude',
        section: 'betriebsausgaben',
        direction: 'expense',
    },
    {
        kz: '9160',
        label: 'Reise- und Fahrtspesen inkl. Kilometergeld und Diäten (ohne tatsächliche Kfz-Kosten)',
        section: 'betriebsausgaben',
        direction: 'expense',
    },
    {
        kz: '9165',
        label: 'Pauschale von 50 % der Kosten einer Wochen-, Monats- oder Jahreskarte für Massenbeförderungsmittel',
        section: 'betriebsausgaben',
        direction: 'expense',
    },
    {
        kz: '9170',
        label: 'Tatsächliche Kfz-Kosten (ohne AfA, Leasing und Kilometergeld)',
        section: 'betriebsausgaben',
        direction: 'expense',
    },
    {
        kz: '9180',
        label: 'Miet- und Pachtaufwand, Leasing',
        section: 'betriebsausgaben',
        direction: 'expense',
    },
    {
        kz: '9190',
        label: 'Provisionen an Dritte, Lizenzgebühren',
        section: 'betriebsausgaben',
        direction: 'expense',
    },
    {
        kz: '9200',
        label: 'Werbe- und Repräsentationsaufwendungen, Spenden, Trinkgelder',
        section: 'betriebsausgaben',
        direction: 'expense',
        hint: 'Bewirtung ist nur zu 50 % abzugsfähig — die Kürzung erfolgt automatisch.',
    },
    {
        kz: '9210',
        label: 'Buchwert abgegangener Anlagen',
        section: 'betriebsausgaben',
        direction: 'expense',
        computed: true,
    },
    {
        kz: '9275',
        label: 'Arbeitszimmer',
        section: 'betriebsausgaben',
        direction: 'expense',
        hint: 'Nur abzugsfähig, wenn das Arbeitszimmer Mittelpunkt der gesamten betrieblichen Tätigkeit ist. Schließt 9215/9216/9217 aus.',
    },
    {
        kz: '9215',
        label: 'Kleines Arbeitsplatzpauschale (300 Euro für ein volles Wirtschaftsjahr)',
        section: 'betriebsausgaben',
        direction: 'expense',
    },
    {
        kz: '9216',
        label: 'Ausgaben für ergonomisch geeignetes Mobiliar (bis höchstens 300 Euro)',
        section: 'betriebsausgaben',
        direction: 'expense',
    },
    {
        kz: '9217',
        label: 'Großes Arbeitsplatzpauschale (1.200 Euro für ein volles Wirtschaftsjahr)',
        section: 'betriebsausgaben',
        direction: 'expense',
    },
    {
        kz: '9220',
        label: 'Zinsen und ähnliche Aufwendungen',
        section: 'betriebsausgaben',
        direction: 'expense',
    },
    {
        kz: '9225',
        label: 'Eigene Pflichtversicherungsbeiträge, Beiträge zu Versorgungs- und Unterstützungseinrichtungen und Beiträge zur Selbständigenvorsorge',
        section: 'betriebsausgaben',
        direction: 'expense',
        hint: 'SVS-Beiträge im Jahr der Zahlung.',
    },
    {
        kz: '9244',
        label: 'Betriebliche Spenden an mildtätige Organisationen',
        section: 'betriebsausgaben',
        direction: 'expense',
    },
    {
        kz: '9245',
        label: 'Betriebliche Spenden an Umweltschutz- und Tierschutzorganisationen',
        section: 'betriebsausgaben',
        direction: 'expense',
    },
    {
        kz: '9246',
        label: 'Betriebliche Spenden an freiwillige Feuerwehren und Landesfeuerwehrverbände',
        section: 'betriebsausgaben',
        direction: 'expense',
    },
    {
        kz: '9209',
        label: 'Betriebliche Spenden an andere begünstigte Einrichtungen',
        section: 'betriebsausgaben',
        direction: 'expense',
    },
    {
        kz: '9230',
        label: 'Übrige Aufwendungen/Betriebsausgaben — Saldo',
        section: 'betriebsausgaben',
        direction: 'expense',
        hint: 'Sammelposten für alles, was keiner anderen Kennzahl zuzuordnen ist.',
    },
    {
        kz: '9233',
        label: 'Nur bei USt-Bruttosystem: bezahlte USt für Lieferungen und sonstige Leistungen',
        section: 'betriebsausgaben',
        direction: 'expense',
    },
    {
        kz: '9259',
        label: 'Pauschalierte Betriebsausgaben',
        section: 'betriebsausgaben',
        direction: 'expense',
        computed: true,
        hint: 'Nur bei Basis- oder Kleinunternehmerpauschalierung.',
    },
    // --- Investitionsfreibetrag ------------------------------------------------
    {
        kz: '9276',
        label: 'Investitionsfreibetrag (§ 11 EStG)',
        section: 'gewinnermittlung',
        direction: 'expense',
        computed: true,
        hint: 'Steht bei einer Pauschalierung auf Grundlage von § 17 nicht zu.',
    },
    {
        kz: '9277',
        label: 'Öko-Investitionsfreibetrag (§ 11 EStG iVm Öko-IFB-VO)',
        section: 'gewinnermittlung',
        direction: 'expense',
        computed: true,
    },
    {
        kz: '9344',
        label: 'Befristet erhöhter Investitionsfreibetrag (§ 11 iVm § 124b Z 480 EStG)',
        section: 'gewinnermittlung',
        direction: 'expense',
        computed: true,
        hint: 'Für Anschaffungen im Zeitraum der befristeten Erhöhung; der Teil über dem Höchstbetrag steht unter 9276.',
    },
    {
        kz: '9345',
        label: 'Befristet erhöhter Öko-Investitionsfreibetrag (§ 11 iVm § 124b Z 480 EStG)',
        section: 'gewinnermittlung',
        direction: 'expense',
        computed: true,
    },
    {
        kz: '9337',
        label: 'Nachzuversteuernder Investitionsfreibetrag',
        section: 'gewinnermittlung',
        direction: 'income',
        computed: true,
    },
    // --- Korrekturen -----------------------------------------------------------
    {
        kz: '9260',
        label: 'Korrekturen zu Kfz-Kosten',
        section: 'gewinnermittlung',
        direction: 'neutral',
    },
    {
        kz: '9270',
        label: 'Korrekturen zu Miet- und Pachtaufwand, Leasing',
        section: 'gewinnermittlung',
        direction: 'neutral',
    },
    {
        kz: '9280',
        label: 'Korrekturen zu Werbe- und Repräsentationsaufwendungen, Spenden, Trinkgelder',
        section: 'gewinnermittlung',
        direction: 'neutral',
    },
    {
        kz: '9290',
        label: 'Sonstige Änderungen — Saldo',
        section: 'gewinnermittlung',
        direction: 'neutral',
    },
    // --- Gewinnfreibetrag ------------------------------------------------------
    {
        kz: '9221',
        label: 'Grundfreibetrag',
        section: 'gewinnermittlung',
        direction: 'expense',
        computed: true,
        hint: '15 % des Gewinns, maximal von einer Bemessungsgrundlage von 33.000 Euro.',
    },
    {
        kz: '9227',
        label: 'Investitionsbedingter Gewinnfreibetrag für körperliche Wirtschaftsgüter',
        section: 'gewinnermittlung',
        direction: 'expense',
        computed: true,
    },
    {
        kz: '9229',
        label: 'Investitionsbedingter Gewinnfreibetrag für Wertpapiere',
        section: 'gewinnermittlung',
        direction: 'expense',
    },
    {
        kz: '9234',
        label: 'Nachzuversteuernder Gewinnfreibetrag',
        section: 'gewinnermittlung',
        direction: 'income',
    },
    // --- Betriebsveräußerung ---------------------------------------------------
    {
        kz: '9020',
        label: 'Höhe des Veräußerungsgewinnes (vor Freibetrag) / Veräußerungsverlustes (§ 24)',
        section: 'sonstige',
        direction: 'income',
    },
    {
        kz: '9021',
        label: 'Freibetrag für Veräußerungsgewinn gemäß § 24 Abs 4',
        section: 'sonstige',
        direction: 'expense',
    },
    {
        kz: '9010',
        label: 'Höhe des Übergangsgewinnes/Übergangsverlustes',
        section: 'sonstige',
        direction: 'neutral',
    },
];
/** Kennzahl every uncategorised business expense falls back to. */
export const E1A_FALLBACK_EXPENSE_KZ = '9230';
/** Kennzahl every uncategorised business income falls back to. */
export const E1A_FALLBACK_INCOME_KZ = '9040';
/**
 * Kennzahlen the form only grew later, with the first year they appear on it.
 * The E 1a 2025 added 9344/9345 for the befristet erhöhte Investitionsfreibetrag
 * (§ 124b Z 480 EStG, BGBl I 79/2025); an older year must not offer them.
 */
const KZ_FROM_YEAR = {
    '9344': 2025,
    '9345': 2025,
};
export function e1aForm(year) {
    return {
        formId: 'E1a',
        fields: FIELDS.filter((field) => year >= (KZ_FROM_YEAR[field.kz] ?? 0)),
        resultKz: '9221',
    };
}
//# sourceMappingURL=e1a.js.map